export const countWords = (text) => {
    if (text === "" || text === undefined) {
      return 0;
    }
    const wordsArray = text.split(" ");
    const wordsCount = wordsArray.length;
    return wordsCount;
  };